<template>
  <div :class="(list.length == 0 ? 'nodata' : '')">
    <div class="shop_main flex" v-for="(item,index) in list" :key="index">
      <div class="selection" @click="selecFg(item.id)" v-if="isAdministr">
        <img v-if="keyObj[item.id]" :src="imgPath + 'xuanzhong.png'" alt />
        <img v-else :src="imgPath + 'weixuanzho.png'" alt />
      </div>
      <img class="shop_img" :src="item.goods_image" alt @click="goShopDel(item.stock_id)" />
      <div class="shop_del" @click="goShopDel(item.stock_id,collectUrl)">
        <div class="name">{{item.goods_name}}</div>
        <div class="flex integral">
          <!-- 活动价-->
          <span>{{item.jinbi}}</span>
          <span class="inte">积分</span>
        </div>
        <div class="flex_b price">
          <div class="through" v-if="is_show_retail_price">{{item.retail_price}}</div>
          <div>已兑：{{item.sales}}</div>
        </div>
      </div>
    </div>
    <div style="height: 3.8rem;"></div>
    <div
      v-if="state==2 && list.length > 0"
      class="administra"
      @click="adminFg"
    >{{!isAdministr ? '管理' : '删除'}}</div>

    <div class="no_time" v-if="list.length == 0">
      <img :src="imgPath + 'quexngye.png'" />
      <div class="no_time_title">暂时还没有商品</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { sendRequest } from '@/assets/public'
import { Dialog, Toast } from 'vant'
export default {
  data() {
    return {
      state: 1, // 1 我能兑换  2 我的收藏
      keyObj: {},
      list: [],
      isAdministr: false,
      page: 1,
      limit: 10,
      isOnld: true,
      is_show_retail_price: false,
      collectUrl: 1,
    }
  },
  mounted() {
    this.init()
  },
  activated() {
    window.addEventListener('scroll', this.handScroll)
  },
  deactivated() {
    window.removeEventListener('scroll', this.handScroll)
  },

  methods: {
    init() {
      this.page = 1
      this.list = []
      this.isOnld = true
      this.state = this.$route.query.state || this.$route.params.state || 1
      document.title = this.state == 1 ? '我能兑换' : '我的收藏'
      if (this.state == 1) {
        this.getGoodsList()
      } else {
        this.getCollectList()
      }
    },
    selecFg(event) {
      Vue.set(this.keyObj, event, this.keyObj[event] ? false : true)
    },
    handScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      let innerHeight =
        window.innerHeight ||
        document.body.clientHeight ||
        document.documentElement.clientHeight
      if (
        scrollTop + innerHeight + 200 >= document.body.scrollHeight &&
        this.isOnld
      ) {
        this.page = this.page + 1
        if (this.state == 1) {
          this.getGoodsList()
        } else {
          this.getCollectList()
        }
      }
    },
    // handScroll () {

    //   if ((document.documentElement.scrollTop + window.innerHeight + 300) >= document.body.scrollHeight && this.isOnld) {

    //   }
    // },

    // 我能兑换商品列表
    async getGoodsList() {
      let { page, limit } = this
      let params = {
        page: page,
        limit: limit,
        goods_type: 0,
        convertible: 1,
        convertible_list: 1,
      }
      if (!this.isOnld) {
        return
      }
      this.isOnld = false
      let { status, content, msg } = await sendRequest('goods/list', params)

      if (status != 200) {
        return
      } else {
        if (content.list.length == 0) {
          this.isOnld = false
          return
        }
        setTimeout(() => {
          this.isOnld = true
        }, 200)
        if (content.is_show_retail_price == 1) {
          this.is_show_retail_price = true
        } else {
          this.is_show_retail_price = false
        }
        let shopData =
          params.page == 1 ? content.list : [...this.list, ...content.list]
        this.list = shopData
      }
    },
    // 收藏
    async getCollectList() {
      let params = {
        page: this.page,
        limit: 10,
      }
      if (!this.isOnld) {
        return
      }
      let { status, content, msg } = await sendRequest(
        'goods/collectList',
        params
      )
      if (status != 200) {
        return
      } else {
        if (content.length == 0 && params.page != 1) {
          this.isOnld = false
          return
        }
        setTimeout(() => {
          this.isOnld = true
        }, 200)
        let shopData = params.page == 1 ? content : [...this.list, ...content]
        this.list = shopData
      }
    },
    async adminFg() {
      if (!this.isAdministr) {
        this.isAdministr = true
        return
      }
      let list = ''
      for (let item in this.keyObj) {
        if (this.keyObj[item]) list += item + ','
      }
      if (list == '') {
        Dialog.alert({
          title: '提示',
          message: '请选择需要删除的商品',
        }).then(() => {
          // on confirm
        })
        return
      }
      let params = {
        ids: list,
      }
      let { status, content, msg } = await sendRequest(
        'goods/delCollect',
        params
      )
      if (status != 200) {
        return
      } else {
        // 删除
        Toast('删除成功')
        this.isAdministr = false
        this.page = 1
        this.selecList = {}
        this.isOnld = true
        this.keyObj = {}
        this.getCollectList()
      }
    },
    goShopDel(event, collectUrl) {
      this.$router.push({
        path: 'shopDetail',
        query: { id: event, collectUrl: 1 },
      })
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (
          to &&
          to.name == 'collecExchange' &&
          from &&
          from.name != 'shopDetail'
        ) {
          this.init()
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped>
.nodata {
  background: #fff;
  height: 100vh;
  overflow: hidden;
}

.no_time img {
  width: 11.96rem;
  margin: 4.92rem auto 0;
  display: block;
}

.no_time .no_time_title {
  font-size: 0.64rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.96rem;
  margin-top: 0.2rem;
  text-align: center;
}

.yuanjia {
  color: #9e9e9e;
  font-size: 0.48rem;
  text-decoration: line-through;
  margin-left: 0.2rem;
}

.flex_b {
  display: flex;
  justify-content: space-between;
}

.shop_main {
  border-top: 0.4rem solid #f5f5f5;
  background: #ffffff;
  padding: 0.4rem 0.8rem;
  flex-wrap: wrap;
}

.shop_main:last-child {
  padding-bottom: 3rem;
}

.shop_main .shop_img {
  width: 4rem;
  height: 4rem;
  margin-right: 0.8rem;
  display: block;
}

.shop_del {
  flex: 1;
}

.shop_del .name {
  font-size: 0.6rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.85rem;
  height: 1.7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}

.integral {
  font-size: 0.72rem;
  font-weight: bold;
  margin-top: 0.72rem;
  color: #fd3d3d;
}

.inte {
  width: 1.4rem;
  height: 0.56rem;
  border: 1px solid #fd3e3e;
  margin-left: 0.2rem;
  border-radius: 0.28rem;
  font-size: 0.4rem;
  font-weight: 500;
  color: rgba(253, 62, 62, 1);
  line-height: 0.56rem;
  text-align: center;
  position: relative;
  top: 0.16rem;
}

.price {
  font-size: 0.48rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.96rem;
}

.through {
  text-decoration: line-through;
}

.administra {
  position: fixed;
  bottom: 0.8rem;
  left: 50%;
  transform: translate(-50%, 0);
  width: 13.6rem;
  height: 2rem;
  background: #fd3e3e;
  color: #ffffff;
  text-align: center;
  line-height: 2rem;
  font-size: 0.6rem;
  border-radius: 0.2rem;
}

.selection {
  width: 0.68rem;
  margin-right: 0.5rem;
}

.selection img {
  width: 0.68rem;
  height: 0.68rem;
  margin-top: 1.8rem;
}
</style>